import { Component, Vue, Watch } from 'vue-property-decorator'
import { getNotice, setNotice, delNotice, getNoticeById, setReadStatus } from '@/api/common'
import { MessageModule } from '@/store/modules/message'
import { UserModule } from '@/store/modules/user'
import realTimeSokcet from '@/utils/socket.io'
import subMenu from '@/components/submenu/index.vue'

@Component({
  components: { subMenu }
})
export default class MessageNotice extends Vue {
  // ------ 变量 ------ 
  page = 1
  total = 0
  pageSize = 20
  noticeInfoShow = false
  delNoticeShow = false
  title = ''
  texts = ''
  noticeList = []
  noticeId = 0
  noticeInfo = {
    isRead: true,
    texts: '',
    title: ''
  }
  socket = null
  dialogShow = false

  get userId() {
    return UserModule.userId
  }

  // ------ 生命周期 ------
  created() {
    this.getNotice()
    if(this.userId) this.initSocket()
  }

  // ------ 方法 ------
  async getNotice() {
    const data: any = await getNotice({ page: this.page, limit: this.pageSize })
    this.noticeList = data.noticeList
    this.total = data.allNum
    MessageModule.getMessageCount()
  }
  closeDialog() {
    this.dialogShow = false
    this.title = ''
    this.texts = ''
  }
  delNotice(id: number) {
    this.noticeId = id
    this.delNoticeShow = true
  }
  async delNoticeSure() {
    await delNotice({ id: this.noticeId })
    this.delNoticeShow = false
    this.$message.success('删除成功')
    this.getNotice()
  }
  async viewInfo(id: number) {
    this.noticeId = id
    this.noticeInfoShow = true
    const data: any = await getNoticeById({ id: this.noticeId })
    this.noticeInfo = data.notice
  }
  async setReadStatus() {
    await setReadStatus({ id: this.noticeId })
    this.viewInfo(this.noticeId)
    MessageModule.getMessageCount()
    this.getNotice()
  }
  async setNotice() {
    if(!this.title) { this.$message.error('请输入通知标题'); return }
    if(!this.texts) { this.$message.error('请输入通知内容'); return }
    await setNotice({ texts: this.texts, title: this.title })
    this.$message.success('新建通知成功')
    this.texts = ''
    this.title = ''
    this.getNotice()
    this.dialogShow = false
  }
  pageChange(val: number) {
    this.page = val
    this.getNotice()
  }

  initSocket() {
    const time = setInterval(() => {
      if(Vue.prototype.$socket.on) {
          realTimeSokcet(this.userId, 'Notice', this.getNotice)
          clearInterval(time)
      }
  }, 100)
}

  @Watch('userId')
  handleWatchUserid() {
    this.initSocket()
  }
}